import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import { ThemeProvider } from './components/ThemeProvider';
import { AuthInit } from './components/AuthInit';
import './styles/globals.css';
import './i18n'; // initialise i18next before rendering

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider>
      <AuthInit>
        <App />
      </AuthInit>
    </ThemeProvider>
  </React.StrictMode>,
);
